import { selectPage } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useGridPage() {
  return useEagGridSelector(selectPage);
}